import React, { memo } from "react";

import "./Header.css";
import menuIcon from "../../Assets/menu-icon.svg";
import logo from "../../Assets/newsie-triumphant-192-removebg.png";
const Header = (props) => {
  const {
    onClickInstructions,
    onClickHamburgerMenu,
    onClickNewsieCategories,
    onClickClueButton,
    encourageClue,
    dontShowClue,
    brandName = "Newsie",
  } = props;
  const clueContainerClassname = `header-hint-button ${
    encourageClue ? "strobe" : ""
  } ${dontShowClue ? "no-clue" : ""}`;
  return (
    <div className="header-container">
      {onClickHamburgerMenu && (
        <button
          className="header-icon-button"
          onClick={onClickHamburgerMenu}
          aria-label="Menu"
        >
          <img src={menuIcon} alt="" className="hamburger-icon" />
        </button>
      )}
      <div className="header-brand">
        <img src={logo} alt="" className="header-brand-logo" />
        <span className="header-brand-name">{brandName}</span>
      </div>
      <div className="header-actions">
        <button className={clueContainerClassname} onClick={onClickClueButton}>
          <span aria-hidden="true">💡</span> Hint
        </button>
        {onClickInstructions && (
          <button
            className="header-icon-button header-help-button"
            onClick={onClickInstructions}
            aria-label="How to play"
          >
            ?
          </button>
        )}
      </div>
    </div>
  );
};

export default memo(Header);
